export const tierTextColor = (tierIndex: number) => {
  switch (tierIndex) {
    case 1:
      return 'text-ph-gray-silver';
    case 2:
      return 'text-ph-yellow';
    case 3:
      return 'text-ph-gray-baltic-strong';
    case 4:
      return 'text-ph-primary-violet';
    default:
      return 'text-ph-gray-evening';
  }
};
